import axios from 'axios'
import env from '@/enviroment';
import lStorage from '@/store/localStorage';
import store from '@/store';
import zdjService from "@/services/zdj/zdjService";
import router from "@/router";
import {rest} from "@/utils/utils";
import i18n from '@/i18n';
const user = {
    namespaced: true,
    state: {
        user_display_name: ".... ........",
        student_status: '',
        level: 0,
        progress: 0,
        is_trial_lesson_finished: false,
        schedule: {
            count: 0,
            max: 0
        },
        phone:null,
        currency:"EUR",
        id:null
    },
    mutations: {
        set: (state, user) => {
            state.user_display_name = user.user_display_name;
            state.student_status = user.student_status;
            state.level = user.level;
            state.progress = user.progress;
            state.schedule = user.schedule;
            state.is_trial_lesson_finished = user.is_trial_lesson_finished;
            state.phone = user.phone;
            state.currency = user.currency;
            state.id = user.id;
        },
        user_display_name: (state, user_display_name) => {
            state.user_display_name = user_display_name;
        },
        student_status: (state, student_status) => {
            state.student_status = student_status;
        },
        level: (state, level) => {
            state.level = level;
        },
        progress: (state, progress) => {
            state.progress = progress;
        },
    },
    actions: {
        updateProfile(context) {
            store.commit('loading/is', true);
            rest.call("profile",{
                language:i18n.getLocale()
            }).then((response)=>{
                store.commit('loading/is', false);
                if(response){
                    context.commit('set',response);
                }
            }).catch((error) => {
                store.commit('loading/is', false);
            })
        },
        logout({commit, state}) {
            zdjService.logout();
            lStorage.remove('auth-token');
            router.push({
                name:"LoginPage",
                params:{
                    locale:i18n.locale,
                }
            });
        }
    },
    getters: {
        get: state => {
            return state
        },
        studentStatus: state => {
            return state.student_status
        },
        level: state => {
            return state.level
        },
        progress: state => {
            return state.progress
        },
    },
    modules: {}
};

export default user;